import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

export const isMobile = (): boolean => {
  return window.innerWidth < 1200;
};

export const isCapacitor = Capacitor.isNativePlatform();

export const openNodrForm = async () => {
  const url = 'https://www.nodrschade.nl/schadeformulier';

  if (isCapacitor) {
    await Browser.open({ url });
  }
};
